/* eslint-disable max-len */
import React from 'react'
import { createIcon } from '@chakra-ui/icon'

const GettingStartedGraphic = createIcon({
  path: (
    <g transform="translate(-83.921 -155.06)" data-name="In sync-rafiki">
      <g transform="translate(-11 4)" data-name="Group 145617">
        <circle
          transform="translate(132.93 151.06)"
          cx="52"
          cy="52"
          r="52"
          fill="#dcf9ee"
          data-name="Ellipse 1737"
        />
        <g transform="translate(94.921 166.59)" opacity=".84">
          <path
            style={{ fill: '#fdb400' }}
            transform="translate(-43.264 -312.65)"
            d="M70.114 396.156a6.533 6.533 0 0 1 .725-5.041 11.479 11.479 0 0 1 3.65-3.693c2.807-1.884 6.624-2.63 9.995-2.8-.048 3.758-2.9 7.037-4.455 8.589-2.459 2.491-8.406 5.5-9.915 2.926"
            data-name="Path 21728"
          />
          <path
            style={{ fill: '#fdb400' }}
            transform="translate(-48.346 -302.94)"
            d="M91.676 368.819a5.54 5.54 0 0 1-5.18 2.051 7.354 7.354 0 0 1-4.831-3.038 3.079 3.079 0 0 1-.73-2.512 2.362 2.362 0 0 1 1.809-1.584 4.767 4.767 0 0 1 2.491.22c2.754.87 5.266 2.217 6.441 4.863"
            data-name="Path 21729"
          />
          <path
            style={{ fill: '#263238' }}
            transform="translate(-52.186 -304.02)"
            d="M105.714 366a4.053 4.053 0 0 1-.59.37l-1.643.95a19.515 19.515 0 0 1-5.819 2.383 11.852 11.852 0 0 1-6.227-.311 8.054 8.054 0 0 1-1.718-.827c-.193-.118-.327-.231-.424-.3s-.14-.113-.134-.118a13.248 13.248 0 0 0 2.33 1.074 12.393 12.393 0 0 0 6.125.236 21.029 21.029 0 0 0 5.749-2.308c.7-.37 1.278-.676 1.675-.875a3.752 3.752 0 0 1 .676-.274z"
            data-name="Path 21730"
          />
          <path
            style={{ fill: '#263238' }}
            transform="translate(-47.188 -303.74)"
            d="M78.37 384.559a1.352 1.352 0 0 1 .2-.225c.166-.15.37-.349.628-.6.537-.537 1.347-1.256 2.34-2.147 2-1.809 4.783-4.294 7.923-6.914s6.034-4.982 8.154-6.635c1.074-.832 1.922-1.5 2.528-1.949l.692-.537a1.633 1.633 0 0 1 .258-.166 1.27 1.27 0 0 1-.225.209l-.666.537-2.48 2.008c-2.088 1.691-4.965 4.042-8.106 6.688s-5.942 5.084-7.961 6.855l-2.416 2.12-.655.564a1.731 1.731 0 0 1-.214.192z"
            data-name="Path 21731"
          />
          <path
            style={{ fill: '#fdb400' }}
            transform="translate(-59.1 -309.36)"
            d="M107.137 377.639a12.98 12.98 0 0 0-2.652 11.557c.268 1.015.843 2.147 1.879 2.281s1.89-.816 2.389-1.739a11.09 11.09 0 0 0-1.363-12.228"
            data-name="Path 21732"
          />
          <path
            style={{ fill: '#263238' }}
            transform="translate(-60.785 -304.63)"
            d="M108.3 382.057a3.223 3.223 0 0 1-.193-.628 6.361 6.361 0 0 1-.161-.752c-.043-.3-.123-.628-.15-1a10.887 10.887 0 0 1-.07-1.235 12.885 12.885 0 0 1 .043-1.417 14.5 14.5 0 0 1 .66-3.183 14.294 14.294 0 0 1 1.417-2.931 11.056 11.056 0 0 1 .837-1.143 10.286 10.286 0 0 1 .821-.923 9.448 9.448 0 0 1 .746-.7 5.364 5.364 0 0 1 .6-.478 2.953 2.953 0 0 1 .537-.365c.038.043-.735.574-1.761 1.659a11.126 11.126 0 0 0-.789.929 13.675 13.675 0 0 0-.805 1.144 14.543 14.543 0 0 0-1.369 2.888 14.987 14.987 0 0 0-.671 3.124c-.038.488-.075.956-.064 1.4a10.943 10.943 0 0 0 .043 1.219c.129 1.479.378 2.381.329 2.392z"
            data-name="Path 21733"
          />
          <path
            transform="translate(-20.281 -250.54)"
            d="M78.78 302.7c6.925-9.539 4.906-22.095.864-32.616-.676-1.755-1.127-3.7-2.512-4.965s-3.725-1.648-5.057-.349c-1.106 1.074-1.149 2.807-1.449 4.332a10.993 10.993 0 0 1-2.791 5.422 4.257 4.257 0 0 1-3.537 1.61c-1.825-.317-2.738-2.373-3.339-4.144l-3.35-9.931A17.367 17.367 0 0 0 55.258 257a5.813 5.813 0 0 0-4.724-2.518 3.523 3.523 0 0 0-3.35 3.65 17.178 17.178 0 0 0 .714 2.217 2.017 2.017 0 0 1-.483 2.147 2.231 2.231 0 0 1-2.222-.145 25.371 25.371 0 0 1-6.441-4.906 35.123 35.123 0 0 0-6.211-5.212 10.047 10.047 0 0 0-7.73-1.4c-2.582.751-4.734 3.221-4.514 5.9s2.544 4.74 4.831 6.211a41.765 41.765 0 0 0 10.934 5.014 3.457 3.457 0 0 1 1.884 1c.794 1.047.081 2.6-.95 3.393a21.842 21.842 0 0 1-3.962 1.89c-1.321.639-2.6 1.761-2.684 3.221-.1 2.061 2.067 3.43 3.983 4.155a35.756 35.756 0 0 0 12 2.319 11.694 11.694 0 0 1 4.343.537 3.474 3.474 0 0 1 2.34 3.382 3.537 3.537 0 0 1-3.14 2.646 25.1 25.1 0 0 1-4.391-.139c-2.743-.081-5.824 1.176-6.651 3.811a5.871 5.871 0 0 0 1.111 5.153 13.717 13.717 0 0 0 4.192 3.441 35.964 35.964 0 0 0 18.036 5.18c6.307 0 11.713-1.272 16.6-5.255"
            fill="#2fbc87"
            data-name="Path 21734"
          />
          <path
            style={{ fill: '#263238' }}
            transform="translate(-21.79 -253.04)"
            d="M80.73 308.407c-1.841-4.085-2.061-4.107-5.5-8.927a167.762 167.762 0 0 0-12.18-14.88l-3.393-3.731c-1.117-1.224-2.222-2.437-3.382-3.559a83.4 83.4 0 0 0-7.01-6.055c-2.324-1.82-4.595-3.457-6.731-4.976s-4.16-2.888-6.055-4.063a66.285 66.285 0 0 0-9.345-4.869c-1.143-.483-2.04-.832-2.657-1.074l-.7-.258-.242-.075a1.348 1.348 0 0 0 .231.107l.687.29c.6.247 1.492.617 2.63 1.122a69.934 69.934 0 0 1 9.27 4.955c1.879 1.186 3.886 2.566 6.017 4.09s4.386 3.173 6.7 4.992a85.028 85.028 0 0 1 6.978 6.044c1.149 1.116 2.244 2.319 3.36 3.548l3.393 3.758a171.449 171.449 0 0 1 12.174 14.826c3.441 4.8 3.672 4.788 5.534 8.846"
            data-name="Path 21735"
          />
          <path
            style={{ fill: '#263238' }}
            transform="translate(-46.364 -253.95)"
            d="M80.756 278.239a4.124 4.124 0 0 0-.086-.816c-.075-.537-.215-1.272-.392-2.2-.36-1.841-.939-4.375-1.61-7.166s-1.2-5.325-1.524-7.172c-.166-.923-.3-1.669-.376-2.19a4.125 4.125 0 0 0-.166-.8 3.493 3.493 0 0 0 .032.816c.043.537.134 1.283.268 2.212.268 1.863.778 4.418 1.433 7.209s1.24 5.244 1.691 7.145c.193.859.36 1.61.494 2.147a3.964 3.964 0 0 0 .236.815z"
            data-name="Path 21736"
          />
          <path
            style={{ fill: '#263238' }}
            transform="translate(-29.086 -271.46)"
            d="M39.29 299.349a5.608 5.608 0 0 0 .939-.2c.6-.15 1.471-.37 2.555-.612 2.147-.494 5.164-1.074 8.508-1.568s6.393-.8 8.589-.961c1.106-.091 2-.14 2.62-.177a5.419 5.419 0 0 0 .961-.086 4.578 4.578 0 0 0-.966-.048c-.623 0-1.524 0-2.63.064-2.222.1-5.287.376-8.642.864a83.859 83.859 0 0 0-8.513 1.675c-1.074.268-1.938.537-2.534.719a5.011 5.011 0 0 0-.886.333z"
            data-name="Path 21737"
          />
          <path
            style={{ fill: '#263238' }}
            transform="translate(-66.025 -261.88)"
            d="M119.044 308a1.293 1.293 0 0 0 .059-.333c.032-.258.064-.574.107-.955.086-.832.182-2.035.279-3.527.193-2.985.338-7.113.429-11.665s.2-8.685.333-11.665l.172-3.532a7.18 7.18 0 0 1 .038-.961 1.03 1.03 0 0 0 0-.338 1.3 1.3 0 0 0-.059.333c0 .258-.059.569-.1.956a98.427 98.427 0 0 0-.279 3.527c-.2 2.979-.338 7.107-.435 11.67s-.2 8.68-.327 11.659l-.172 3.532a7.168 7.168 0 0 1-.038.961 1.492 1.492 0 0 0-.007.338z"
            data-name="Path 21738"
          />
          <path
            style={{ fill: '#263238' }}
            transform="translate(-37.072 -290.32)"
            d="M56.53 337.141a1.5 1.5 0 0 0 .344 0h.982l3.591-.07c3.038-.059 7.231-.091 11.868-.123s8.836-.1 11.868-.22c1.519-.059 2.748-.123 3.591-.182l.977-.075a1.4 1.4 0 0 0 .338-.048 1.55 1.55 0 0 0-.344 0h-.975l-3.6.07c-3.033.059-7.231.091-11.863.123s-8.836.1-11.868.22c-1.519.059-2.748.118-3.6.183l-.972.07a1.071 1.071 0 0 0-.337.052z"
            data-name="Path 21739"
          />
        </g>
        <g transform="translate(-4510.4 13819)" data-name="Group 145628">
          <path
            transform="translate(4659.4 -13635)"
            d="M28.718 78.938V63.8l-10.5-8.076-1.818-5.656H0l2.877-12.92 8.277-8.076 11.1-1.413L35.179 14.94l24.63-11.306L76.364 0v12.719l-6.864 21-11.1 14.734-7.47 7.268-1.215 11.306-9.691 9.085-11.305 2.826zm18.776-61.172-3.028 8.883 4.441 6.864L57.79 32.3l4.24-7.672-4.24-4.845-6.258-2.019h-4.038z"
            fill="#edf4fe"
            data-name="Exclusion 1"
          />
          <g transform="translate(4658.3 -13635)">
            <path
              style={{
                fill: 'none',
                stroke: '#2c93fa',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeWidth: '4px',
              }}
              transform="translate(-48.013 -48.178)"
              d="M127.082 49.254a.841.841 0 0 0-.631-.648c-10.391-2.541-34.395 6.514-47.413 19.523a56.349 56.349 0 0 0-6.323 7.471 23.514 23.514 0 0 0-11.442 1.43c-9.648 4.242-12.455 15.321-13.238 20.077a1.72 1.72 0 0 0 1.873 1.987l15.491-1.7a34.453 34.453 0 0 0 .21 3.5 3.468 3.468 0 0 0 1.013 2.119l6 6a3.468 3.468 0 0 0 2.121 1.013 34.382 34.382 0 0 0 3.476.21l-1.7 15.478a1.72 1.72 0 0 0 1.985 1.871c4.758-.764 15.86-3.571 20.077-13.217a23.633 23.633 0 0 0 1.452-11.406 56.16 56.16 0 0 0 7.489-6.323c13.066-12.994 22.064-36.47 19.561-47.379zM95.907 79.8a8.15 8.15 0 1 1 5.769 2.393 8.159 8.159 0 0 1-5.769-2.393z"
              data-name="Path 23176"
            />
            <path
              style={{
                fill: 'none',
                stroke: '#2c93fa',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeWidth: '4px',
              }}
              transform="translate(-60.945 -293.94)"
              d="M72.721 352a8.61 8.61 0 0 0-5.035 2.453C64.319 357.832 64 370.344 64 370.344s12.52-.319 15.889-3.69a8.547 8.547 0 0 0 2.455-5.039"
              data-name="Path 23177"
            />
          </g>
        </g>
      </g>
    </g>
  ),
  viewBox: '0 0 142.01 114.54',
})

export default GettingStartedGraphic
